import { h } from 'preact';
import * as BaseComp from 'components/bolt/quotesCarousel/quotesCarousel.js';
// import s from 'components/bolt/quotesCarousel/quotesCarousel.sss';

export default class QuotesCarousel extends BaseComp.default {

	componentDidMount() {
		if (!this.props.isShowtimes) {
			this.getTopGap();
			setTimeout(() => {
				this.setCarouselHeight();
			}, 400);
		}
		if (this.items.length > 1) {
			this.startCarousel();
		}
	}

}
